







import Vue from "vue";
import LoginForm from "@/components/Login/LoginForm.vue";
import { Credentials } from "vue/types/vue";
import { UserService } from "../services";

export default Vue.extend({
  data() {
    return {
      wrongLogin: false,
      loading: false,
      loginMessage: ""
    };
  },
  components: { LoginForm },
  methods: {
    login: async function (payload: Credentials) {
      try {
        this.loading = true;
        this.wrongLogin = false;
        this.loginMessage = "";
        const auth = await UserService.userLogin(payload);
        const self = this;
        await this.$store.dispatch("checkStatus");

        if (auth.status === 200) {
          if (self.$store.getters.isAdmin) {
            self.$router.push({ name: "admin" });
          } else {
            self.$router.push({ name: "user-puzzles" });
          }
        } else if (auth.status === 429) {
          this.loginMessage =
            "För många inloggningsförsök. Vänta en minut och försök igen.";
          self.wrongLogin = true;
        } else {
          this.loginMessage = "Felaktigt användarnamn/lösenord";
          self.wrongLogin = true;
        }
      } catch (error: any) {
        if (error.response.status === 429) {
          this.loginMessage =
            "För många inloggningsförsök. Vänta en minut och försök igen.";
        }
        else {
          this.loginMessage = "Felaktigt användarnamn/lösenord";
        }

        this.wrongLogin = true;
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    test: function (event: Event): void {
      console.log(event);
    }
  }
});
